var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 482886"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 482885"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2578",
    d: "M1 12V17C1 18.1046 1.89543 19 3 19H8",
    stroke: "#18964E",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2580",
    d: "M19 12V17C19 18.1046 18.1046 19 17 19H12",
    stroke: "#18964E",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2579",
    d: "M8 1L3 1C1.89543 1 1 1.89543 1 3L1 8",
    stroke: "#18964E",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2581",
    d: "M12 1L15.5 1L17 1C18.1046 1 19 1.89543 19 3L19 8",
    stroke: "#18964E",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 482891"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 10H14",
    stroke: "#18964E",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 14V6",
    stroke: "#18964E",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrNew);
export default __webpack_public_path__ + "static/media/qr-new.5844752c6ed52769b94a5ddbaf199667.svg";
export { ForwardRef as ReactComponent };